import styled from 'styled-components';

export const EmojiSuggestionLi = styled.li`
  list-style-type: none;
  display: flex;
  align-items: center;
  gap: 8px;
`;
